











import Vue from 'vue'
import Navigation from './Navigation.vue'

export default Vue.extend({
  components: {
    Navigation
  }
})
